import axios from "axios";
import Config from "src/config";

const v2_actionPromptImprovement = async (data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/ai/prompt/improve`,
        data: data
    });
};

export default v2_actionPromptImprovement;
